export default "__VITE_ASSET__RFptA9YQ__"